import React from 'react';
import Skeleton from 'react-loading-skeleton';
import OrderByBtns from './OrderByBtns';

type Props = {
  totalHotels: number | undefined | null;
  orderBy: any;
  orderByAsc: boolean;
  onOrderChange: (orderBy: string, orderByAsc: boolean) => void;
  searchHotelLoading: boolean;
  selectedLocationName: string;
  openSearchOnMobile: () => void;
};
const isMobile = window.innerWidth < 1300;
export default function OrderAndFilterBtns({
  searchHotelLoading,
  totalHotels,
  onOrderChange,
  orderBy,
  orderByAsc,
  selectedLocationName,
  openSearchOnMobile,
}: Props) {
  return (
    <div className="row y-gap-10 items-center justify-between">
      <div className="col-auto">
        <div className="text-18" style={{ lineHeight: '50px' }}>
          {searchHotelLoading ? (
            <Skeleton width={200} />
          ) : (
            <>
              <span className="fw-500 ">{totalHotels} hotels</span> in {selectedLocationName}
            </>
          )}
        </div>
      </div>
      {/* End .col */}
      {searchHotelLoading ? (
        <div className="col-auto">
          <div className="row x-gap-20 y-gap-20">
            <div className="col-auto">
              <Skeleton width={200} height={40} />
            </div>
            <div className="col-auto d-none xl:d-block">
              <Skeleton width={100} height={40} className="rounded-100" />
            </div>
          </div>
        </div>
      ) : totalHotels ? (
        <>
          {isMobile ? (
            <div className="col-auto">
              <div className="row x-gap-20 y-gap-20">
                <div className="col-auto">
                  <OrderByBtns orderBy={orderBy} orderByAsc={orderByAsc} onOrderChange={onOrderChange} />
                </div>
                <div className="col-auto d-none xl:d-block">
                  <button onClick={openSearchOnMobile} className="button -blue-1 h-40 px-20 rounded-100 bg-blue-1-05 text-15 text-blue-1">
                    <i className="icon-up-down text-14 mr-10" />
                    Filter
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="col-auto">
              <OrderByBtns orderBy={orderBy} orderByAsc={orderByAsc} onOrderChange={onOrderChange} />
            </div>
          )}
        </>
      ) : null}

      {/* End .col */}
    </div>
  );
}
